/**
 * Folds Arabic for SEARCHING only — never for anything that gets displayed or
 * stored.
 *
 * Typed Arabic is almost never byte-identical to Quranic orthography, and this
 * codebase has now been bitten by that three times: a hand-written basmalah
 * matched zero surahs, 95:1 and 97:1 carry a stray shadda, and a surah search
 * for الكهف found nothing because the stored name is سُورَةُ الكَهۡفِ — the
 * سورة prefix plus full diacritics.
 *
 * Nobody types diacritics into a search box, so matching has to happen on the
 * bare skeleton of the word.
 */

/** Harakat, sukun, shadda, superscript alef, and the Quranic annotation marks. */
const DIACRITICS = /[ؐ-ًؚ-ٰٟۖ-ۭ]/g;

/** Every alef and hamza-carrier a reader might type as a plain ا. */
const ALEF = /[آأإٱٲٳ]/g;

export function foldArabic(s: string): string {
  return s
    .replace(DIACRITICS, '')
    .replace(ALEF, 'ا')
    .replace(/ى/g, 'ي')   // dotless ya -> ya
    .replace(/ة/g, 'ه')   // ta marbuta -> ha
    .replace(/ـ/g, '')         // tatweel
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * The same folding, minus the word سورة, so "الكهف", "سورة الكهف" and
 * "سُورَةُ الكَهۡفِ" all match each other.
 */
export function foldSurahName(s: string): string {
  return foldArabic(s).replace(/^سوره\s+/, '');
}
